/* istanbul ignore file */

import { useRootStore } from '@/stores/root';
import { useUserStore } from '@/stores/user';

export function startDataSyncCheck(
  syncFrequencyInMinutes: number,
  retryFrequencyInMinutes: number
) {
  const user = useUserStore();
  const rootStore = useRootStore();
  const dataSyncCheckInterval = setInterval(async () => {
    if (document.hidden) {
      return;
    }
    if (user.isUserActive()) {
      clearInterval(dataSyncCheckInterval);
      startActiveUserCheck(syncFrequencyInMinutes, retryFrequencyInMinutes);
      return;
    }

    rootStore.load();
  }, syncFrequencyInMinutes * 60000);
}

function startActiveUserCheck(
  syncFrequencyInMinutes: number,
  retryFrequencyInMinutes: number
) {
  const user = useUserStore();
  const rootStore = useRootStore();
  const userCheckInterval = setInterval(async () => {
    if (user.isUserActive() || document.hidden) {
      return;
    }

    rootStore.load();
    clearInterval(userCheckInterval);
    startDataSyncCheck(syncFrequencyInMinutes, retryFrequencyInMinutes);
  }, retryFrequencyInMinutes * 60000);
}
